var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDislike = function SvgDislike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    className: "dislike_svg__icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#2B4FB9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M19.939 13.3V3.6m-3.3 9.7V4m0 9.3-4.5 7c-1.5-.4-2.4-1.7-2-3l1.8-4h-5.5m10.2 0h5.1m-15.4 0c-1.7 0-2.9-1-2.5-2.6l1.5-5.8m16.4-1.3h-14s-2.1 0-2.4 1.4",
    className: "dislike_svg__stroke"
  })));
};
export { SvgDislike as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBjbGFzcz0iaWNvbiIgd2lkdGg9IjI1IiBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgMjUgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggY2xhc3M9InN0cm9rZSIgZD0iTTE5LjkzOSAxMy4zVjMuNjAwMDRNMTYuNjM5IDEzLjI5OTlWMy45OTk5NE0xNi42MzkgMTMuMjk5OUwxMi4xMzkgMjAuM0MxMC42MzkgMTkuOSA5LjczODk3IDE4LjYgMTAuMTM5IDE3LjNMMTEuOTM5IDEzLjNINi40Mzg5Nk0xNi42MzkgMTMuMjk5OUwyMS43MzkgMTMuM002LjMzOTAyIDEzLjMwMDFDNC42MzkwMiAxMy4zMDAxIDMuNDM5MDIgMTIuMzAwMSAzLjgzOTAyIDEwLjcwMDFMNS4zMzkwMiA0LjkwMDA5TTIxLjczOSAzLjYwMDA0SDcuNzM4OTlDNy43Mzg5OSAzLjYwMDA0IDUuNjM4OTkgMy42MDAwMyA1LjMzODk5IDUuMDAwMDMiIHN0cm9rZT0iIzJCNEZCOSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPg==";